declare var __non_webpack_require__: any;
import { makeStateKey, StateKey } from '@angular/core';
import { TransferState } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
export class TranslatesServerLoaderService implements TranslateLoader {

  constructor(
    private prefix: string = 'i18n',
    private suffix: string = '.json',
    private transferState: TransferState) {
  }

  public getTranslation(lang: string): Observable<any> {
    return Observable.create((observer: any) => {
      const langFileUrl = `./browser${this.prefix}/${lang}${this.suffix}`;
      const result = __non_webpack_require__(langFileUrl);

      if (result)
        console.log("===========LANGUAGE FIND FROM JSON============");

      const key: StateKey<number> = makeStateKey<number>('transfer-translate-' + lang);
      this.transferState.set(key, result);

      observer.next(result);
      observer.complete();
    });
  }
}
